export const apiPath: string = `/api/v2/cdn`;
export const rtpObserveInterval: number = 15000;
export const timeout: number = 5000;

